// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__tg-Sl","label":"SetPasswdForm_label__-1Xnz"};